
import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

const Footer = () => {
  const intl = useIntl();

  // Helper function to safely format messages
  const safeFormatMessage = (id) => {
    try {
      return intl.formatMessage({ id });
    } catch (error) {
      console.warn(`Missing translation for: ${id}`);
      return id.split('.').pop(); // Fallback to last part of the ID
    }
  };

  return (
    <footer className="bg-indigo-900 text-white">
      <div className="container mx-auto px-8 py-8">
        <div className="flex flex-wrap justify-between">
          <div className="w-full md:w-1/3 mb-6 md:mb-0">
            <h2 className="text-xl font-bold mb-4">Pokedle</h2>
            <p className="text-sm">{safeFormatMessage('footer.description')}</p>
          </div>
          <div className="w-full md:w-1/3 mb-6 md:mb-0">
            <h3 className="text-lg font-semibold mb-4">{safeFormatMessage('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-indigo-300">{safeFormatMessage('footer.home')}</Link></li>
              <li><Link to="/how-to-play" className="hover:text-indigo-300">{safeFormatMessage('footer.howToPlay')}</Link></li>
              <li><Link to="/stickman-hook" className="hover:text-indigo-300">Stickman Hook</Link></li>
              <li><Link to="/monkey-mart" className="hover:text-indigo-300">Monkey Mart</Link></li>
              <li><Link to="/vex5" className="hover:text-indigo-300">Vex 5</Link></li>
              <li><Link to="/color-tunnel" className="hover:text-indigo-300">Color Tunnel</Link></li>
              <li><Link to="/capybara-clicker" className="hover:text-indigo-300">Capybara Clicker 3D</Link></li>
              <li><Link to="/pokemon-clicker" className="hover:text-indigo-300">Pokemon Clicker</Link></li>
              <li><Link to="/pokemon-clicker-2" className="hover:text-indigo-300">Pokemon Clicker 2</Link></li>
              <li><Link to="/time-shooter-3" className="hover:text-indigo-300">Time Shooter 3 Unblocked</Link></li>
            </ul>
          </div>
          <div className="w-full md:w-1/3">
            <h3 className="text-lg font-semibold mb-4">{safeFormatMessage('footer.connectWithUs')}</h3>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-indigo-300">Twitter</a>
              <a href="#" className="hover:text-indigo-300">Facebook</a>
              <a href="#" className="hover:text-indigo-300">Instagram</a>
            </div>
          </div>
        </div>
        <div className="mt-8 text-center text-sm">
          <p>{safeFormatMessage('footer.copyright')}</p>
          <a href="/sitemap.xml" className="hover:text-indigo-300 mt-2 inline-block">{safeFormatMessage('footer.sitemap')}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
